module.exports = __webpack_public_path__ + "img/app_icon_70.eb749df4.png";